<template>
  <cardContainer>
    <el-card
      :body-style="{ padding: '0px' }"
      class="clickable scoping"
      @click.native="fetchCards(scope, gameid)">
      <div style="padding: 4rem 0 0 2rem;">
        <h2 class="hyphenate">{{scope}}</h2>
        <div class="bottom clearfix"></div>
      </div>
    </el-card>
  </cardContainer>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import posed from 'vue-pose'

export default {
  props: ['scope', 'types', 'decks'],
  components: { 
    cardContainer: posed.div({
      '1': { opacity: 1, y: 0 },
      '2': { opacity: 0, y: -500 }
    })
  },
  data() {
    return {
      scopingCards: {},
      gameid: ''
    }
  },
  created() {
    let params = (new URL(document.location)).searchParams
    this.gameid = params.get('id')
  },
  methods: {
    fetchCards: function(scope, gameid) {
      var vm = this

      try {
        if (typeof this.decks[scope] !== 'undefined') throw 'cached'

        const loader = vm.$loading({ fullscreen: true })

        axios.get('/api/scopes?industry=' + encodeURIComponent(scope) + '&gameid=' + encodeURIComponent(this.gameid))
          .then(function (response) {
            return vm.sortCards(response.data)
          })
          .then(function (response) {
            vm.loadCards(response)
          })
          .finally(() => loader.close())
          .catch(function (error) {
            throw error
          })
      } catch (err) {
        if (err == 'cached') vm.loadCards(vm.decks[scope])
        else console.error(err)
      }
    },
    loadCards: function(deck) {
      let vm = this
      _.each(deck, function(val, key) {
        vm.$emit('load', key, deck[key])
      })
      vm.$root.$emit('startTimer')
      vm.$emit('tick', 'down')
    },
    sortCards: function(deck) {
      var vm = this
      _.each(vm.types, function(val) {
        vm.scopingCards[val.type] = {
          deck: _.filter(deck, {type: val.type }),
          leader: val.leader,
          active: 0
        }
        vm.scopingCards[val.type].deck = _.shuffle(vm.scopingCards[val.type].deck)
      })
      vm.$emit('sorted', vm.scopingCards, vm.scope)
      return vm.scopingCards
    }
  }
}
</script>

<style>
  .scoping .el-card {
    /* border: 2px dashed; */
    border-radius: 1rem;
    /* background-color: unset; */
    /* box-shadow: none; */
    margin: 1rem;
    /* color: white; */
    width: 13.5rem; 
    height: 20rem;
  }
</style>
